import { Box, Section } from '@factorialco/deprecated-design-system'
import { EmployeeBlocksEmployeeFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import GeneralBlock from 'modules/employees/components/blocks/General/GeneralBlock'

interface Props {
  employee: EmployeeBlocksEmployeeFragment
  isCurrent: boolean
  readonly?: boolean
}

const General = ({ employee, isCurrent, readonly }: Props) => {
  return (
    <Section
      illustration="user"
      title={i18n.t('employee_form.general_information.title')}
      description={i18n.tCurrent('employee_form.general_information.description', isCurrent)}
    >
      <Box
        gap="s24"
        background="grey200"
        padding="s32"
        width="s360"
        alignSelf="flexEnd"
        borderRadius={{
          all: 'abs004',
        }}
      >
        <GeneralBlock employee={employee} readonly={readonly} />
      </Box>
    </Section>
  )
}

export default observer(General)
